import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-retry-successful',
    templateUrl: './retry-successful.component.html',
    styleUrls: ['./retry-successful.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RetrySuccessfulComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
